var _defs, _polygon, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _polygon2, _polygon3, _polygon4, _g9, _g0, _g1, _polygon5, _polygon6, _polygon7, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _polygon8, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _polygon9, _g32;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenBarn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8b7f6e;\n      }\n\n      .cls-2 {\n        fill: #5d6864;\n      }\n\n      .cls-3 {\n        fill: #a09f9f;\n      }\n\n      .cls-4 {\n        fill: #ececec;\n      }\n\n      .cls-5 {\n        fill: #65635f;\n      }\n\n      .cls-6 {\n        fill: #b1b1b0;\n      }\n\n      .cls-7 {\n        fill: #493522;\n      }\n\n      .cls-8 {\n        fill: #76614a;\n      }\n\n      .cls-9 {\n        fill: #3f3e3e;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "687.27 803.7 37.21 553.46 434.85 458.12 1042.79 608.84 687.27 803.7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "955.78 461.46 961.68 466.96 981.7 510.69 980.55 515.12 955.78 461.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "955.78 461.46 953.15 464.18 977.91 517.84 980.55 515.12 955.78 461.46"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "982.05 469.33 982.05 615.27 985.99 613.03 985.99 469.33 982.05 469.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "978.11 469.33 978.11 613.03 982.05 615.27 982.05 469.33 978.11 469.33"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "445.64 331.87 445.64 463.11 449.58 465.85 449.58 331.87 445.64 331.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "449.58 331.87 449.58 465.85 453.52 464.9 453.52 331.87 449.58 331.87"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "113.16 545.97 113.16 553.05 449.64 465.91 449.64 458.83 113.16 545.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "113.16 545.97 449.64 458.83 445.7 457.03 113.16 541.69 113.16 545.97"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.88 379.75 107.88 552.25 111.82 553.95 111.82 379.75 107.88 379.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "111.82 379.75 111.82 553.95 115.75 552.38 115.75 379.75 111.82 379.75"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "111.97 427.83 111.82 419.78 129.28 374.96 133.26 372.7 111.97 427.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "111.97 427.83 115.75 427.83 137.05 372.7 133.26 372.7 111.97 427.83"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "188.63 372.38 188.63 522.37 192.56 525.11 192.56 372.38 188.63 372.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.56 372.38 192.56 525.11 196.5 523.54 196.5 372.38 192.56 372.38"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "192.72 413.33 192.56 405.28 210.02 360.47 214.01 358.21 192.72 413.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "192.72 413.33 196.5 413.33 217.8 358.21 214.01 358.21 192.72 413.33"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "265.44 371.76 265.44 502.99 269.38 505.74 269.38 371.76 265.44 371.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "269.38 371.76 269.38 505.74 273.32 504.17 273.32 371.76 269.38 371.76"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "269.53 404.83 269.38 396.77 286.84 351.96 290.82 349.7 269.53 404.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "269.53 404.83 273.32 404.83 294.61 349.7 290.82 349.7 269.53 404.83"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "337.55 352.94 337.55 484.17 341.49 486.92 341.49 352.94 337.55 352.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "341.49 352.94 341.49 486.92 345.43 485.35 345.43 352.94 341.49 352.94"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "341.65 400.27 341.49 392.21 358.95 347.4 362.93 345.14 341.65 400.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "341.65 400.27 345.43 400.27 366.72 345.14 362.93 345.14 341.65 400.27"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "401.32 336.64 401.32 467.88 405.26 470.63 405.26 336.64 401.32 336.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "405.26 336.64 405.26 470.63 409.2 469.06 409.2 336.64 405.26 336.64"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "405.42 388.43 405.26 380.38 422.72 335.57 426.71 333.31 405.42 388.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "405.42 388.43 409.2 388.43 430.5 333.31 426.71 333.31 405.42 388.43"
  })))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "221.24 381.76 107.88 383.53 107.88 373.89 221.24 371 221.24 381.76"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "221.24 369.44 106.65 371.99 106.65 373.89 221.24 371 221.24 369.44"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "218.8 367.94 104.22 370.48 104.22 372.38 218.8 369.49 218.8 367.94"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "225.5 593.97 225.5 601.06 561.99 513.92 561.99 506.84 225.5 593.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "225.5 593.97 561.99 506.84 558.05 505.04 225.5 589.7 225.5 593.97"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "495.18 524.29 499.12 523.62 499.12 353.21 495.18 353.21 495.18 524.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "491.25 522.05 495.18 524.29 495.18 353.21 491.25 354.72 491.25 522.05"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "571.36 310.64 499.12 353.21 495.18 353.21 567.43 310.64 571.36 310.64"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "495.34 395.79 495.18 387.73 512.64 342.92 516.63 340.66 495.34 395.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "495.34 395.79 499.12 395.79 520.42 340.66 516.63 340.66 495.34 395.79"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "491.25 355.78 491.25 351.75 567.43 305.64 567.43 310.64 491.25 355.78"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "824.65 360.18 838.31 389.72 839.69 379.24 830.87 360.18 824.65 360.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "830.87 360.18 839.69 379.24 844.85 380.97 835.23 360.18 830.87 360.18"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "841.5 360.18 841.5 561.32 845.44 559.82 845.44 360.18 841.5 360.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "837.57 360.18 837.57 559.09 841.5 561.32 841.5 360.18 837.57 360.18"
  })))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "221.24 363.99 328.4 294.97 518.79 289.4 426.17 358.91 229.11 375.47 221.24 363.99"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "216.43 381.76 216.01 373.21 454.97 357.3 451.03 363.03 216.43 381.76"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "216.43 381.76 502.35 360.87 500.22 357.3 221.24 378.72 216.43 381.76"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "511.95 339.12 258.03 348.14 258.12 345.05 512.07 335.44 511.95 339.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "511.85 342.2 257.93 351.22 258.03 348.14 511.97 338.53 511.85 342.2"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "544.6 315.33 290.68 324.35 290.78 321.26 544.72 311.65 544.6 315.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "544.51 318.41 290.58 327.43 290.68 324.35 544.62 314.74 544.51 318.41"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "561.68 513.92 565.62 512.41 565.62 286.62 561.68 286.62 561.68 513.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "557.74 511.68 561.68 513.92 561.68 286.62 557.74 288.12 557.74 511.68"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "841.5 554.28 504.16 697.68 504.16 704.76 841.5 561.36 841.5 554.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "841.5 554.28 504.16 697.68 502.19 693.52 837.57 552.49 841.5 554.28"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "982.06 607.77 682.23 768.22 682.23 775.3 982.06 614.85 982.06 607.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "982.06 607.77 682.23 768.22 680.26 764.06 978.12 605.98 982.06 607.77"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "503.63 463.9 503.78 455.84 486.32 411.03 482.34 408.77 503.63 463.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "503.63 463.9 499.85 463.9 478.55 408.77 482.34 408.77 503.63 463.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "504.16 704.76 508.1 703.25 508.1 413.19 504.16 413.19 504.16 704.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "500.22 703.53 504.16 704.76 504.16 413.19 500.22 414.7 500.22 703.53"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "504.49 537.74 504.34 529.68 525.45 479.51 529.43 477.25 504.49 537.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "504.49 537.74 508.27 537.74 533.22 477.25 529.43 477.25 504.49 537.74"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "571.81 460.99 570.43 471.47 536.84 398.85 543.07 398.85 571.81 460.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "571.81 460.99 576.96 462.72 543.38 390.1 543.07 398.85 571.81 460.99"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "573.62 667.92 577.56 666.41 577.56 410.29 573.62 410.29 573.62 667.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "569.68 665.68 573.62 667.92 573.62 410.29 569.68 411.8 569.68 665.68"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "641.27 432.05 639.89 442.53 606.3 369.91 612.53 369.91 641.27 432.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "641.27 432.05 646.42 433.79 612.84 361.16 612.53 369.91 641.27 432.05"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "643.08 638.99 647.02 637.48 647.02 381.36 643.08 381.36 643.08 638.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "639.14 636.75 643.08 638.99 643.08 381.36 639.14 382.87 639.14 636.75"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "710.73 401.9 709.35 412.38 675.77 339.76 681.99 339.76 710.73 401.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "710.73 401.9 715.89 403.63 682.3 331.01 681.99 339.76 710.73 401.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "712.54 608.84 716.48 607.33 716.48 351.21 712.54 351.21 712.54 608.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "708.6 606.6 712.54 608.84 712.54 351.21 708.6 352.72 708.6 606.6"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "765.58 367.32 777.27 392.59 778.65 382.11 771.81 367.32 765.58 367.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "771.81 367.32 778.65 382.11 783.8 383.84 776.16 367.32 771.81 367.32"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "780.46 367.32 780.46 580.43 784.4 578.92 784.4 367.32 780.46 367.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "776.52 367.32 776.52 578.19 780.46 580.43 780.46 367.32 776.52 367.32"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "294.04 576.07 297.97 575.41 297.97 369.85 294.04 369.85 294.04 576.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "290.1 573.84 294.04 576.07 294.04 369.85 290.1 371.36 290.1 573.84"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "370.21 327.28 297.97 369.85 294.04 369.85 366.28 327.28 370.21 327.28"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "294.19 412.43 294.04 404.37 311.5 359.56 315.48 357.3 294.19 412.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "294.19 412.43 297.97 412.43 319.27 357.3 315.48 357.3 294.19 412.43"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "290.1 372.42 290.1 368.4 366.28 322.28 366.28 327.28 290.1 372.42"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "367.17 557.24 371.11 556.57 371.11 364.71 367.17 364.71 367.17 557.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "363.23 555 367.17 557.24 367.17 364.71 363.23 366.22 363.23 555"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "443.35 322.15 371.11 364.71 367.17 364.71 439.41 322.15 443.35 322.15"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "367.33 407.29 367.17 399.24 384.63 354.43 388.62 352.17 367.33 407.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "367.33 407.29 371.11 407.29 392.41 352.17 388.62 352.17 367.33 407.29"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "363.23 367.29 363.23 363.26 439.41 317.15 439.41 322.15 363.23 367.29"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "426.17 542.83 430.11 542.17 430.11 354.88 426.17 354.88 426.17 542.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "422.23 540.59 426.17 542.83 426.17 354.88 422.23 356.39 422.23 540.59"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "502.35 312.31 430.11 354.88 426.17 354.88 498.41 312.31 502.35 312.31"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "426.33 397.46 426.17 389.4 443.63 344.59 447.61 342.33 426.33 397.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "426.33 397.46 430.11 397.46 451.4 342.33 447.61 342.33 426.33 397.46"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "422.23 357.45 422.23 353.42 498.41 307.31 498.41 312.31 422.23 357.45"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "225.17 601.07 229.11 600.4 229.11 367.94 225.17 367.94 225.17 601.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "221.24 598.83 225.17 601.07 225.17 367.94 221.24 369.44 221.24 598.83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "225.33 414.21 225.17 406.16 242.63 361.34 246.62 359.09 225.33 414.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "225.33 414.21 229.11 414.21 250.41 359.09 246.62 359.09 225.33 414.21"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "328.4 291.93 205.8 369.75 206.2 370.94 328.4 293.12 328.4 291.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "328.4 291.93 501.54 413.19 501.54 414.39 328.4 293.12 328.4 291.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "855.77 358.91 501.54 413.19 501.54 414.39 855.77 360.1 855.77 358.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "855.77 358.91 501.54 413.19 328.4 291.93 699.81 276.3 855.77 358.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "328.4 305.74 210.35 381.76 210.35 371 328.4 294.97 328.4 305.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "328.4 305.74 501.54 426.77 501.54 416 328.4 294.97 328.4 305.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "206.2 370.94 210.35 371 328.4 294.97 328.4 293.12 206.2 370.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "210.35 381.76 328.4 305.74 332.16 308.37 216.43 381.76 210.35 381.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "328.4 294.97 328.4 293.12 501.54 414.39 501.54 416 328.4 294.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "851.11 367.79 501.54 426.77 501.54 416 851.11 362.66 851.11 367.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "851.11 362.66 851.11 360.82 501.54 414.39 501.54 416 851.11 362.66"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "560.04 282.18 722.37 379.35 730.83 378.06 568.43 281.83 560.04 282.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "445.33 287.01 613.3 396.07 622.14 394.71 454.01 286.64 445.33 287.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "373.93 290.01 544.67 406.58 553.73 405.2 382.77 289.64 373.93 290.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "388.19 289.41 558.42 404.48 567.44 403.1 397 289.04 388.19 289.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "603.22 280.36 763.01 373.12 771.33 371.85 611.49 280.01 603.22 280.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "531.3 283.39 695.19 383.52 703.75 382.21 539.77 283.03 531.3 283.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "574.42 281.58 735.93 377.27 744.35 375.98 582.77 281.22 574.42 281.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "588.81 280.97 749.48 375.2 757.84 373.92 597.13 280.62 588.81 280.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "359.68 290.61 530.9 408.69 540 407.3 368.55 290.24 359.68 290.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "473.95 285.8 640.66 391.87 649.41 390.53 482.56 285.44 473.95 285.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "345.43 291.21 517.12 410.81 526.26 409.41 354.33 290.84 345.43 291.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "431.03 287.61 599.6 398.17 608.49 396.8 439.74 287.24 431.03 287.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "459.64 286.41 626.99 393.97 635.78 392.62 468.28 286.04 459.64 286.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "488.28 285.2 654.31 389.78 663.02 388.45 496.85 284.84 488.28 285.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "516.95 283.99 681.58 385.6 690.19 384.28 525.45 283.64 516.95 283.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "402.47 288.81 572.16 402.37 581.14 401 411.24 288.44 402.47 288.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "502.61 284.6 667.96 387.69 676.61 386.36 511.14 284.24 502.61 284.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "416.75 288.21 585.89 400.27 594.82 398.9 425.49 287.84 416.75 288.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "545.67 282.79 708.79 381.43 717.3 380.13 554.09 282.43 545.67 282.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "660.93 277.93 816.98 364.85 825.08 363.61 669.05 277.59 660.93 277.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "328.4 291.93 501.54 413.19 512.51 411.51 340.13 291.44 328.4 291.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "646.49 278.54 803.51 366.92 811.67 365.67 654.64 278.2 646.49 278.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "632.05 279.15 790.03 368.98 798.24 367.73 640.25 278.8 632.05 279.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "855.77 358.91 699.81 276.3 689.86 276.72 843.86 360.73 855.77 358.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "617.63 279.76 776.53 371.05 784.79 369.79 625.86 279.41 617.63 279.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "683.46 276.99 675.39 277.33 830.42 362.79 838.48 361.56 683.46 276.99"
  })))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "845.51 368.85 845.51 394.89 504.09 459.78 504.16 426.33 845.51 368.85"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "654.52 554.04 660.41 559.53 680.43 603.26 679.28 607.69 654.52 554.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "654.52 554.04 651.88 556.76 676.64 610.41 679.28 607.69 654.52 554.04"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "680.78 561.9 680.78 775.3 684.72 773.06 684.72 561.9 680.78 561.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "676.84 561.9 676.84 773.06 680.78 775.3 680.78 561.9 676.84 561.9"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "715.46 534.83 721.35 540.32 741.37 584.05 740.22 588.48 715.46 534.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "715.46 534.83 712.83 537.55 737.58 591.2 740.22 588.48 715.46 534.83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "741.72 542.69 741.72 736.29 745.66 734.05 745.66 542.69 741.72 542.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "737.79 542.69 737.79 734.05 741.72 736.29 741.72 542.69 737.79 542.69"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "768.41 510.18 774.31 515.68 794.33 559.4 793.18 563.84 768.41 510.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "768.41 510.18 765.78 512.9 790.54 566.56 793.18 563.84 768.41 510.18"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "794.68 518.04 794.68 708.02 798.62 705.78 798.62 518.04 794.68 518.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "790.74 518.04 790.74 705.78 794.68 708.02 794.68 518.04 790.74 518.04"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "821.37 497.06 827.26 502.56 847.28 546.28 846.13 550.72 821.37 497.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "821.37 497.06 818.74 499.78 843.49 553.44 846.13 550.72 821.37 497.06"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "847.63 504.92 847.63 679.02 851.57 676.78 851.57 504.92 847.63 504.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "843.7 504.92 843.7 676.78 847.63 679.02 847.63 504.92 843.7 504.92"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "874.32 479.47 880.22 484.97 900.24 528.69 899.09 533.13 874.32 479.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "874.32 479.47 871.69 482.19 896.45 535.85 899.09 533.13 874.32 479.47"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "900.59 487.33 900.59 651.76 904.53 649.52 904.53 487.33 900.59 487.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "896.65 487.33 896.65 649.52 900.59 651.76 900.59 487.33 896.65 487.33"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "921.37 461.46 927.26 466.96 947.28 510.69 946.13 515.12 921.37 461.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "921.37 461.46 918.74 464.18 943.5 517.84 946.13 515.12 921.37 461.46"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "947.64 469.33 947.64 626.2 951.57 623.96 951.57 469.33 947.64 469.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "943.7 469.33 943.7 623.96 947.64 626.2 947.64 469.33 943.7 469.33"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "504.09 458.59 680.43 567.64 680.58 568.92 504.09 459.78 504.09 458.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "992.65 470.35 680.43 567.64 680.58 568.92 993.1 471.81 992.65 470.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "992.65 470.35 680.43 567.64 504.09 458.59 845.51 394.89 992.65 470.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "504.09 472.41 682.13 582.23 680.78 570.66 504.09 461.63 504.09 472.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "504.09 461.63 504.09 459.78 680.58 568.92 680.78 570.66 504.09 461.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "988.81 481.66 682.13 582.23 680.78 570.66 988.81 475.38 988.81 481.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "988.81 475.38 988.81 473.12 680.58 568.92 680.78 570.66 988.81 475.38"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "506.2 458.2 681.7 567.25 691.7 564.13 517.01 456.18 506.2 458.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "521.21 455.4 695.79 562.85 705.81 559.73 531.94 453.39 521.21 455.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "536.22 452.6 709.88 558.46 719.92 555.34 546.88 450.61 536.22 452.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "551.23 449.8 723.97 554.07 734.03 550.94 561.82 447.82 551.23 449.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "566.24 446.99 738.06 549.68 748.14 546.54 576.76 445.03 566.24 446.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "581.26 444.19 752.14 545.29 762.26 542.14 591.7 442.24 581.26 444.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "596.27 441.39 766.23 540.9 776.37 537.75 606.65 439.46 596.27 441.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "611.29 438.59 780.32 536.51 790.48 533.35 621.59 436.67 611.29 438.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "626.31 435.79 794.4 532.12 804.59 528.95 636.54 433.88 626.31 435.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "641.33 432.99 808.49 527.73 818.7 524.55 651.49 431.09 641.33 432.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "656.35 430.18 822.57 523.35 832.8 520.16 666.44 428.3 656.35 430.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "671.37 427.38 836.65 518.96 846.91 515.76 681.4 425.51 671.37 427.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "686.39 424.58 850.74 514.57 861.02 511.36 696.35 422.72 686.39 424.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "701.42 421.77 864.82 510.18 875.13 506.97 711.31 419.93 701.42 421.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "716.45 418.97 878.9 505.79 889.24 502.57 726.27 417.14 716.45 418.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "731.48 416.16 892.98 501.41 903.34 498.18 741.24 414.34 731.48 416.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "746.51 413.36 907.06 497.02 917.45 493.78 756.2 411.55 746.51 413.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "761.55 410.55 921.13 492.63 931.55 489.38 771.17 408.76 761.55 410.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "776.58 407.75 935.21 488.25 945.66 484.99 786.14 405.97 776.58 407.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "791.62 404.94 949.28 483.86 959.76 480.59 801.12 403.17 791.62 404.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "806.66 402.14 963.36 479.47 973.87 476.2 816.1 400.38 806.66 402.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "821.71 399.33 977.43 475.09 987.97 471.8 831.08 397.58 821.71 399.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "992.65 470.35 845.51 394.89 836.76 396.52 991.5 470.7 992.65 470.35"
  })))), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "104.22 370.48 208.29 368.17 255.75 338.05 104.22 370.48"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "116.07 367.94 212.68 365.39 217.47 362.34 130.38 364.88 116.07 367.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "144.65 361.83 221.49 359.79 226.28 356.75 159.22 358.71 144.65 361.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "171.55 356.07 229.78 354.53 234.51 351.53 186.18 352.94 171.55 356.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "198.47 350.31 238.08 349.26 242.75 346.3 213.16 347.16 198.47 350.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "251.59 340.68 242.14 340.96 227.17 344.16 246.94 343.64 251.59 340.68"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBarn);
export default __webpack_public_path__ + "static/media/Open-Barn.75e0305175e7cccc719592af33fecf43.svg";
export { ForwardRef as ReactComponent };